// Department color mapping (background + text classes for Tailwind)
export const DEPT_COLORS = {
  "Dezvoltare IT": "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300 ring-emerald-200 dark:ring-emerald-800/50",
  "Vanzari": "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300 ring-orange-200 dark:ring-orange-800/50",
  "Administrare Proiecte": "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 ring-blue-200 dark:ring-blue-800/50",
  "Operational IT": "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-300 ring-cyan-200 dark:ring-cyan-800/50",
  "Resurse Umane": "bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-300 ring-pink-200 dark:ring-pink-800/50",
  "Financiar": "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300 ring-yellow-200 dark:ring-yellow-800/50",
  "Contabilitate": "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300 ring-amber-200 dark:ring-amber-800/50",
  "Administrativ": "bg-slate-100 text-slate-800 dark:bg-slate-800/50 dark:text-slate-300 ring-slate-200 dark:ring-slate-700",
  "Infrastructura IT": "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300 ring-indigo-200 dark:ring-indigo-800/50",
  "Managementul Produselor": "bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-300 ring-rose-200 dark:ring-rose-800/50",
  "Arhivare": "bg-stone-100 text-stone-800 dark:bg-stone-800/50 dark:text-stone-300 ring-stone-200 dark:ring-stone-700",
  "Juridic": "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300 ring-red-200 dark:ring-red-800/50",
  "MARKETING": "bg-fuchsia-100 text-fuchsia-800 dark:bg-fuchsia-900/30 dark:text-fuchsia-300 ring-fuchsia-200 dark:ring-fuchsia-800/50",
  "Management general": "bg-zinc-900 text-zinc-50 dark:bg-zinc-100 dark:text-zinc-900 ring-zinc-800 dark:ring-zinc-200",
};

// Avatar color for the initials circle (more saturated)
export const AVATAR_COLORS = {
  "Dezvoltare IT": "bg-emerald-500 text-white",
  "Vanzari": "bg-orange-500 text-white",
  "Administrare Proiecte": "bg-blue-500 text-white",
  "Operational IT": "bg-cyan-500 text-white",
  "Resurse Umane": "bg-pink-500 text-white",
  "Financiar": "bg-yellow-500 text-zinc-900",
  "Contabilitate": "bg-amber-500 text-zinc-900",
  "Administrativ": "bg-slate-500 text-white",
  "Infrastructura IT": "bg-indigo-500 text-white",
  "Managementul Produselor": "bg-rose-500 text-white",
  "Arhivare": "bg-stone-500 text-white",
  "Juridic": "bg-red-500 text-white",
  "MARKETING": "bg-fuchsia-500 text-white",
  "Management general": "bg-zinc-900 text-white dark:bg-zinc-100 dark:text-zinc-900",
};

export function deptBadgeClass(dept) {
  return DEPT_COLORS[dept] || "bg-zinc-100 text-zinc-800 dark:bg-zinc-800 dark:text-zinc-200 ring-zinc-200 dark:ring-zinc-700";
}

export function deptAvatarClass(dept) {
  return AVATAR_COLORS[dept] || "bg-zinc-700 text-white";
}

// Format ISO date (YYYY-MM-DD) to Romanian DD.MM.YYYY
export function formatRoDate(iso) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso || "";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
}

// Competencies = personal skills + skills the person mentors on (deduped, case-insensitive)
export function effectiveSkills(emp) {
  const seen = new Map();
  for (const s of [...(emp?.skills || []), ...(emp?.mentor_skills || [])]) {
    const k = (s || "").trim().toLowerCase();
    if (k && !seen.has(k)) seen.set(k, s);
  }
  return Array.from(seen.values());
}

export function copyToClipboard(text) {
  if (!text) return Promise.reject(new Error("empty"));
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }
  const el = document.createElement("textarea");
  el.value = text;
  document.body.appendChild(el);
  el.select();
  try {
    document.execCommand("copy");
    return Promise.resolve();
  } finally {
    document.body.removeChild(el);
  }
}
